export const cameraView07DeckSprayhoodImageOptions = {
  legacy: true,
  prefix: 'X4_9_Exterior',
  angle: 'Camera View 07 - Deck Sprayhood',
  staticOptions: {
    BowSprit: 1,
    HullTreatment: 1,
    TeakOnBathingPlatform: 1,
    Boom: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/X49/views/CameraView07DeckSprayhood.js